// ABOUTME: One scale for the breathing scene's stage and the round's ring, as the Reset reference derives them.
// ABOUTME: Stage = column scale x face scale x frame scale; ring = column scale x frame scale; the frame scale is the shared S22 clamp.

import { useFrameScale } from './useFrameScale';

// The reference's frame widths, column scales and face scales (frameSc, colSc and rsFaceSc in its template).
// v28 raises the whole scene on desktop so the ring stands wholly above the console card (SPEC 1).
const DESKTOP = { frameWidth: 1080, columnScale: 1.28, faceScale: 1.2, raise: 83 };
const PHONE = { frameWidth: 390, columnScale: 0.88, faceScale: 1.45, raise: 0 };

export interface BreathStageScale {
  ringScale: number; // multiplies the ring's 470 px base
  stageScale: number; // multiplies the scene's 850 x 370 px stage
  raisePx: number; // how far the scene and the ring stand above the host's centre, in px
}

export function breathStageScaleFor(mob: boolean, frameSc: number): BreathStageScale {
  const { columnScale, faceScale, raise } = mob ? PHONE : DESKTOP;
  return { ringScale: columnScale * frameSc, stageScale: columnScale * faceScale * frameSc, raisePx: raise };
}

export function useBreathStageScale(): BreathStageScale {
  const desktop = useFrameScale(DESKTOP.frameWidth);
  const phone = useFrameScale(PHONE.frameWidth);
  return breathStageScaleFor(desktop.mob, (desktop.mob ? phone : desktop).frameSc);
}
